import $ from 'jquery';
import * as Utilities from '../utilities/legacy-utilities';
import { data as SiteUrlData } from '../settings/siteUrlData';

/* global _OL_ORIGIN */

const referrerHMAC = SiteUrlData ? SiteUrlData.referrerHMAC : undefined;
$.ajaxPrefilter((settings, originalSettings, xhr) => {
  const safeMethod = (method) => {
    return /^(GET|HEAD|OPTIONS|TRACE)$/.test(method);
  };

  if (!safeMethod(settings.type) && !settings.crossDomain) {
    const csrfToken = Utilities.getCookie('csrftoken');
    xhr.setRequestHeader('X-CSRFToken', csrfToken);
    // eslint-disable-next-line no-param-reassign
    settings.csrfToken = csrfToken;
  } else if (Utilities.sameOrigin(settings.url, _OL_ORIGIN)) {
    // eslint-disable-next-line no-param-reassign
    settings.xhrFields = { withCredentials: true };
    if (!safeMethod(settings.type) && typeof referrerHMAC !== 'undefined') {
      xhr.setRequestHeader('Referrer-HMAC', referrerHMAC);
      // eslint-disable-next-line no-param-reassign
      settings.referrerHMAC = referrerHMAC;
    }
  }
});
